import React from "react";
import {Card, CardContent, CardHeader, Container} from "@mui/material";
import { object, string, number, boolean, date, TypeOf, coerce } from 'zod';
import {formatDateTime, formatDateTimeParam, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import * as crudgen from "../../../../share";
import {DEBOUNCE_TIME} from "../../../../utils/constants";
import {useLocation} from "react-router";

import { CuttingState, CuttingStatePairs, toString as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { ShipmentState, ShipmentStatePairs, toString as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { ShipmentType, ShipmentTypePairs, toString as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { UserType, UserTypePairs, toString as toStringUserType } from "../../../types/models/UserType.d";
import { CordwoodMeasurementType, CordwoodMeasurementTypePairs, toString as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";



import LocationFormSelect from "../../../../location/components/location/LocationForm/LocationFormSelect";
import { PrimaryLocation } from "../../../../location/types/models/Location.ts";

import BuyerFormSelect from "../../../../timber/components/buyer/BuyerForm/BuyerFormSelect";
import { PrimaryBuyer } from "../../../../timber/types/models/Buyer.ts";

import RoadCarrierFormSelect from "../../../../timber/components/roadCarrier/RoadCarrierForm/RoadCarrierFormSelect";
import { PrimaryRoadCarrier } from "../../../../timber/types/models/RoadCarrier.ts";
import { t, msg } from "@lingui/core/macro"
import { useFormContext } from "react-hook-form";































export const initialFormStateFn = () => { return {
    
        
        key: "",
        
    
        
        shipmentAt: formatDateTimeParam(new Date()),
        
    
        
        sourceLocationId: null,
        
    
        
        sourceParcel: "",
        
    
        
        buyerId: null,
        
    
        
        targetAddress: "",
        
    
        
        targetCity: "",
        
    
        
        targetCountry: "",
        
    
        
        state: ShipmentState.Upcoming,
        
    
        
        roadCarrierId: null,
        
    
        
        truckRegistrationNumber: "",
        
    
        
        truckerName: "",
        
    
        
        workOrder: "",
        
    
        
        shipmentOrder: "",
        
    
        
        forPersonalUse: false,
        
    
        
        description: "",
        
    
} }

export const useLocationFormState = (oldState) => {
    const initialFormState = initialFormStateFn()
    let location = useLocation();
    

    return initialFormState
}

export const formObject = {
    
    
        key:
        string()
        .trim()
        .min(1, msg`Key is required`),
    
    
        shipmentAt:
        string()
        .trim()
        .nullish(),
    
    
        sourceLocationId:
        string()
                .nanoid(msg`Source Location is required`)
                .nullish(),
    
    
        sourceParcel:
        string()
        .trim()
        .nullish(),
    
    
        buyerId:
        string()
                .nanoid(msg`Buyer is required`)
                .nullish(),
    
    
        targetAddress:
        string()
        .trim()
        .nullish(),
    
    
        targetCity:
        string()
        .trim()
        .nullish(),
    
    
        targetCountry:
        string()
        .trim()
        .nullish(),
    
    
        state:
        string()
        .trim()
        .min(1, msg`State is required`),
    
    
        roadCarrierId:
        string()
                .nanoid(msg`Road Carrier is required`)
                .nullish(),
    
    
        truckRegistrationNumber:
        string()
        .trim()
        .nullish(),
    
    
        truckerName:
        string()
        .trim()
        .nullish(),
    
    
        workOrder:
        string()
        .trim()
        .nullish(),
    
    
        shipmentOrder:
        string()
        .trim()
        .nullish(),
    
    
        forPersonalUse:
        boolean()
        .nullish(),
    
    
        description:
        string()
        .trim()
        .nullish(),
    
};

export const formSchema = object(formObject);
export const closedFormSchema = object({
    ...formObject,
    shipmentAt:
        string()
            .min(1, msg`Shipment at is required`),
    buyerId:
        string()
            .nanoid(msg`Buyer is required`),
    roadCarrierId:
        string()
            .nanoid(msg`Road Carrier is required`),
    truckerName:
        string()
            .min(1, msg`Trucker name at is required`),
    forPersonalUse:
        boolean(),
});

const ShipmentUpdateForm = ({watch, prefix = ''})  => {

    const { setValue } = useFormContext();

    const onBuyerChange = (buyer: any) => {
        if (buyer?.addressIdAddress) {
            setValue(prefix + 'targetAddress', buyer.addressIdAddress.address || '');
            setValue(prefix + 'targetCity', buyer.addressIdAddress.city || '');
            setValue(prefix + 'targetCountry', buyer.addressIdAddress.country || '');
        }
    }
    return (
        <Container>
            
            
   
   <crudgen.FormInput
       required
       name={ prefix + 'key' }
       aria-label="key"
       data-testid="key"
       label={t`Key`}
       
       type='text'
       
   />
   
   
            
            
   
        
           <crudgen.FormDateTime
                
                name={ prefix + 'shipmentAt' }
                aria-label="shipmentAt"
                label={t`Shipment At`}
           />
       
   
   
            
            
   
    
    <LocationFormSelect
        type="dynamicSelect"
        name="sourceLocationId"
        label={t`Source Location`}
        prefix={prefix}
        required={ false }
    />
   
   
   
            
            
   
   <crudgen.FormInput
       
       name={ prefix + 'sourceParcel' }
       aria-label="sourceParcel"
       data-testid="sourceParcel"
       label={t`Source Parcel`}
       
       type='text'
       
   />
   
   
            
            
   
    
    <BuyerFormSelect
        type="dynamicSelect"
        name="buyerId"
        label={t`Buyer`}
        prefix={prefix}
        required={ false }
        onValueChange={onBuyerChange}
    />
   
   
   
            
            
   
   <crudgen.FormInput
       
       name={ prefix + 'targetAddress' }
       aria-label="targetAddress"
       data-testid="targetAddress"
       label={t`Target Address`}
       
       type='text'
       
   />
   
   
            
            
   
   <crudgen.FormInput
       
       name={ prefix + 'targetCity' }
       aria-label="targetCity"
       data-testid="targetCity"
       label={t`Target City`}
       
       type='text'
       
   />
   
   
            
            
   
   <crudgen.FormInput
       
       name={ prefix + 'targetCountry' }
       aria-label="targetCountry"
       data-testid="targetCountry"
       label={t`Target Country`}
       
       type='text'
       
   />
   
   
            
            
   
    <crudgen.FormSelect
        required
        name={ prefix + 'state' }
        aria-label="state"
        label={t`State`}
        options={ ShipmentStatePairs }
        optionLabelMap={ toStringShipmentState }
    />
   
   
            
            
   
    
    <RoadCarrierFormSelect
        type="dynamicSelect"
        name="roadCarrierId"
        label={t`Road Carrier`}
        prefix={prefix}
        required={ false }
    />
   
   
   
            
            
   
   <crudgen.FormInput
       
       name={ prefix + 'truckRegistrationNumber' }
       aria-label="truckRegistrationNumber"
       data-testid="truckRegistrationNumber"
       label={t`Truck Registration Number`}
       
       type='text'
       
   />
   
   
            
            
   
   <crudgen.FormInput
       
       name={ prefix + 'truckerName' }
       aria-label="truckerName"
       data-testid="truckerName"
       label={t`Trucker Name`}
       
       type='text'
       
   />
   
   
            
            
   
   <crudgen.FormInput
       
       name={ prefix + 'workOrder' }
       aria-label="workOrder"
       data-testid="workOrder"
       label={t`Work Order`}
       
       type='text'
       
   />
   
   
            
            
   
   <crudgen.FormInput
       
       name={ prefix + 'shipmentOrder' }
       aria-label="shipmentOrder"
       data-testid="shipmentOrder"
       label={t`Shipment Order`}
       
       type='text'
       
   />
   
   
            
            
   
   <crudgen.FormCheckbox
       
       name={ prefix + 'forPersonalUse' }
       aria-label="forPersonalUse"
       data-testid="forPersonalUse"

       label={t`For Personal Use`}
   />
   
   
            
            
   
   <crudgen.FormInput
       
       name={ prefix + 'description' }
       aria-label="description"
       data-testid="description"
       label={t`Description`}
       
       type='text'
       
   />
   
   
            
        </Container>
    )
}

export default ShipmentUpdateForm;
